export default "__VITE_ASSET__B8TUFJlm__"